import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-department',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './delete-department.component.html',
  styleUrls: ['./delete-department.component.scss']
})
export class DeleteDepartmentComponent {
  @Input() orgId: string = ''; // Organization ID passed from the parent
  @Input() departmentDataToEdit: any = ''; // Department data passed from the parent
  @Output() close = new EventEmitter<void>(); // Event to close the dialog
  @Output() reload = new EventEmitter<void>(); // Event to reload the department list

  isLoading: boolean = false; // Loading indicator

  constructor(
    private orgService: OrganizationService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteDepartment() {
    this.isLoading = true;
    const payload = {
      organization_id: this.orgId,
      dept_id: this.departmentDataToEdit.dept_id // Get the department ID to delete
    };


   this.orgService.deleteDepartment(payload).subscribe({
    next: (response) => {
      this.isLoading = false;
      this.close.emit();
      this.reload.emit();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Department deleted successfully!'
      });
    },
    error: (error) => {
      console.error('Error deleting department:', error);
      this.isLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete department!'
      });
    }
  });
  
  }
}
